module.exports = __webpack_public_path__ + "static/img/best-workplaces.41945d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/best-workplaces.png
// module id = 0h9r
// module chunks = 0